import React, { useState, useEffect, useMemo } from "react";
import ProgressBar from "../../../utils/progressBar/ProgressBar.js";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel,
  Textarea,
} from "@chakra-ui/react";
import Select from "react-select";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Spinner,
  Button,
  ModalCloseButton,
} from "@chakra-ui/react";
import { Trash2 } from "lucide-react";
import { createPayment, updatePayment } from "../../../redux/api/paymentReceiveApi/PaymentRecevieApi.js";
import { useDispatch, useSelector } from "react-redux";
import { addPaymentReceiveAction, updatePaymentReceiveAction } from "../../../redux/reduxSlice/PaymentReceiveSlice.js";
import { toast } from "react-toastify";
import { toTitleCase } from "../../../utils/commonFunction/CommonFunction";
function PaymentReceiveForm(props) {
  const { isDrawerOpen, isUpdateMode, paymentReceiveId, paymentReceiveROWId, setIsUpdateMode, dataToEdit, onNewDataAdded } = props
  const { closeDrawer } = props;
  const [showProgressBar, setShowProgressBar] = useState(false);
  const dispatch = useDispatch();
  const clientList = useSelector((state) => state.utils.clientList);
  const userList = useSelector((state) => state.utils.userList);
  useEffect(() => {
    if (isUpdateMode && dataToEdit) {
      setFormData(dataToEdit); // <-- preload form for editing
    }
  }, [isUpdateMode, dataToEdit]);

  const [formData, setFormData] = useState({
    customerName: "",
    salesPerson: "",
    paymentDate: "",
    payment: "",
    paymentMode: "",
    despiteTo: "",
    reference: "",
    amountReceived: "",
    amountForPayment: "",
    amountRefunded: "",
    amountInExcess: "",
    items: [],
    ROWID: "",
  })

  const handleOnClose = () => {
    closeDrawer();
    setFormData({
      customerName: "",
      salesPerson: "",
      paymentDate: "",
      payment: "",
      paymentMode: "",
      despiteTo: "",
      reference: "",
      amountReceived: "",
      amountForPayment: "",
      amountRefunded: "",
      amountInExcess: "",
      items: [],
    })
  }

  const [itemRows, setItemRows] = useState([
  {
    date: "",
    invoiceNumber: "",
    invoiceAmount: "",
    amountDue: "",
    paymentReceivedOn: "",
    payment: ""
  }
]);

const handleRowChange = (index, field, value) => {
  const updatedRows = [...itemRows];
  updatedRows[index][field] = value;
  setItemRows(updatedRows);

  // Update formData.items whenever itemRows change
  const updatedItems = updatedRows.map((row) => ({
    itemDate: row.date || "",
    invoiceNo: row.invoiceNumber || "",
    invoiceAmount: Number(row.invoiceAmount) || 0,
    amountDue: row.amountDue || "",
    paymentReceivedDate: row.paymentReceivedOn || "",
    payment: Number(row.payment) || 0,
  }));

  setFormData((prev) => ({
    ...prev,
    items: updatedItems,
  }));
};


const handleAddRow = () => {
  const updatedRows = [
    ...itemRows,
    {
      date: "",
      invoiceNumber: "",
      invoiceAmount: "",
      amountDue: "",
      paymentReceivedOn: "",
      payment: ""
    }
  ];
  setItemRows(updatedRows);

  const updatedItems = updatedRows.map((row) => ({
    itemDate: row.date || "",
    invoiceNo: row.invoiceNumber || "",
    invoiceAmount: Number(row.invoiceAmount) || 0,
    amountDue: row.amountDue || "",
    paymentReceivedDate: row.paymentReceivedOn || "",
    payment: Number(row.payment) || 0,
  }));

  setFormData((prev) => ({
    ...prev,
    items: updatedItems,
  }));
};

const handleDeleteRow = (index) => {
  const updatedRows = itemRows.filter((_, i) => i !== index);
  setItemRows(updatedRows);

  const updatedItems = updatedRows.map((row) => ({
    itemDate: row.date || "",
    invoiceNo: row.invoiceNumber || "",
    invoiceAmount: Number(row.invoiceAmount) || 0,
    amountDue: row.amountDue || "",
    paymentReceivedDate: row.paymentReceivedOn || "",
    payment: Number(row.payment) || 0,
  }));

  setFormData((prev) => ({
    ...prev,
    items: updatedItems,
  }));
};


  const customerOptions = clientList?.map((c) => ({
    value: c.clients?.ROWID,
    label: `${c.clients?.firstName || ""} ${c.clients?.lastName || ""}`.trim(),
  }));

  const salesPersonOptions = userList?.map((u) => ({
    value: u.employees?.ROWID,
    label: u.employees?.employeeName,
  }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowProgressBar(true);
console.log("formData",formData)
    createPayment(formData)
      .then((response) => {
        if (response.data.success) {
          const ROWID = response.data.purchaseReceive?.[0]?.ROWID;
          dispatch(addPaymentReceiveAction({ ROWID, formData }));
          toast.success("Payment received successfully!");
          handleOnClose();
        } else {
          toast.error("Unable to add payment. Please try again!");
        }
      })
      .catch((error) => {
        console.error("API Error", error);
        toast.error("Failed to add payment. Please try again.");
      })
      .finally(() => {
        setShowProgressBar(false);
      });
  };


  const handelOnUpdate = (e) => {
    e.preventDefault();
    setShowProgressBar(true);
    updatePayment(formData, paymentReceiveId).then((response) => {
      console.log({ response })
      toast.success("Invoices Updated successfully!");
      handleOnClose();
      if (response.data.success) {
        dispatch(updatePaymentReceiveAction({ formData, paymentReceiveId }))
      }
    }).catch((error) => {
      setShowProgressBar(false);
      console.log({ error })
    }).finally(() => {
      setShowProgressBar(false);
    })
  };

  useEffect(() => {
    if (isUpdateMode && dataToEdit) {
      setFormData((prev) => ({
        ...prev, ...props.dataToEdit,
      }))
    }
    if (dataToEdit?.itemRows) {
      setItemRows(JSON.parse(dataToEdit?.itemRows))
    }
  }, [isUpdateMode, dataToEdit])

  const handleChange = (e, index = null, field = null) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const fieldOptions = [
    { label: "Sales", value: "sales" },
    { label: "Marketing", value: "marketing" },
    { label: "Finance", value: "finance" },
  ];


  const paymentOptions = [
    { value: '', label: 'Select' },
    { value: 'Cash', label: 'Cash' },
    { value: 'Debit Card', label: 'Debit Card' },
    { value: 'Cheque', label: 'Cheque' },
    { value: 'Wallet', label: 'Wallet' }
  ];
  const paymentOptions1 = [
    { value: '', label: 'Select' },
    { value: 'Cash', label: 'Cash' },
    { value: 'Other Current Liability', label: 'Other Current Liability' }
  ];
  return (
    <>
      <Drawer
        isOpen={props.isDrawerOpen}
        onClose={props.closeDrawer}
        placement="right"
        size="xl"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>{isUpdateMode ? "Update Payment Recevie" : "Create Payment Recevie"} </DrawerHeader>
          <DrawerBody>
            {showProgressBar && <ProgressBar colorScheme="pink" />}
            <form onSubmit={isUpdateMode ? handelOnUpdate : handleSubmit}>
              <div className="card">
                <div className="card-body">

                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <Select
                        name="customerName"
                        options={customerOptions}
                        value={customerOptions.find(
                          (opt) => opt.value === formData?.customerName
                        )}
                        onChange={(selected) =>
                          setFormData((prev) => ({
                            ...prev,
                            customerName: selected?.value || "",
                          }))
                        }
                        isClearable
                        placeholder="Select Customer"
                      />
                      <FormLabel className="small-label ps-3">Customer Name</FormLabel>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          type="date"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Payment Date"
                          name="paymentDate"
                          value={formData?.paymentDate}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel
                        className="small-label ps-3"
                        style={{ paddingLeft: "2px" }}
                      >
                        Payment Date
                      </FormLabel>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <Select
                        name="salesPerson"
                        options={salesPersonOptions}
                        value={salesPersonOptions.find(
                          (opt) => opt.value === formData?.salesPerson
                        )}
                        onChange={(selected) =>
                          setFormData((prev) => ({
                            ...prev,
                            salesPerson: selected?.value || "",
                          }))
                        }
                        isClearable
                        placeholder="Select Sales Person"
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: 200,
                            overflowY: "auto",
                          }),
                        }}
                      />
                      <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>
                        Sales Person <span style={{ color: "red" }}>*</span>
                      </FormLabel>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          type="text"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Reference"
                          name="reference"
                          value={formData?.reference}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel
                        className="small-label ps-3"
                        style={{ paddingLeft: "2px" }}
                      >
                        Reference
                      </FormLabel>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          type="number"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Payment"
                          name="payment"
                          value={formData?.payment}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel
                        className="small-label ps-3"
                        style={{ paddingLeft: "2px" }}
                      >
                        Payment#
                      </FormLabel>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <Select
                        name="paymentMode"
                        options={paymentOptions}
                        value={paymentOptions.find(
                          (opt) => opt.value === formData?.paymentMode
                        )}
                        onChange={(selected) =>
                          setFormData((prev) => ({
                            ...prev,
                            paymentMode: selected?.value || "",
                          }))
                        }
                        isClearable
                        placeholder="Select Payment Mode"
                      />
                      <FormLabel className="small-label ps-3">
                        Payment Mode
                      </FormLabel>
                    </div>

                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <Select
                        name="despiteTo"
                        options={paymentOptions1}
                        value={paymentOptions1.find(
                          (opt) => opt.value === formData?.despiteTo
                        )}
                        onChange={(selected) =>
                          setFormData((prev) => ({
                            ...prev,
                            despiteTo: selected?.value || "",
                          }))
                        }
                        isClearable
                        placeholder="Select Account"
                      />
                      <FormLabel className="small-label ps-3">
                        Deposite To
                      </FormLabel>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          type="number"
                          style={{ outline: "none", border: "none" }}
                          placeholder="amountReceived"
                          name="amountReceived"
                          value={formData?.amountReceived}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel
                        className="small-label ps-3"
                        style={{ paddingLeft: "2px" }}
                      >
                        Amount Received
                      </FormLabel>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          type="number"
                          style={{ outline: "none", border: "none" }}
                          placeholder="amountForPayment"
                          name="amountForPayment"
                          value={formData?.amountForPayment}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel
                        className="small-label ps-3"
                        style={{ paddingLeft: "2px" }}
                      >
                        Amount For Payment
                      </FormLabel>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          type="number"
                          style={{ outline: "none", border: "none" }}
                          placeholder="amountRefunded"
                          name="amountRefunded"
                          value={formData?.amountRefunded}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel
                        className="small-label ps-3"
                        style={{ paddingLeft: "2px" }}
                      >
                        Amount Refunded
                      </FormLabel>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          type="number"
                          style={{ outline: "none", border: "none" }}
                          placeholder="amountInExcess"
                          name="amountInExcess"
                          value={formData?.amountInExcess}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel
                        className="small-label ps-3"
                        style={{ paddingLeft: "2px" }}
                      >
                        Amount In Excess
                      </FormLabel>
                    </div>
                  </div>

                </div>
              </div>

              <div className="card mt-3">
                <div className="card-body">
                  <div className="w-100">
                    <div className="custom-scroll">
                      <table
                        className="table-class"
                        style={{ paddingBottom: "50px" }}
                      >
                        <thead>
                          <tr>
                            <th colSpan={7}>
                              <h5 style={{ fontSize: "15px" }}>Item Table</h5>
                            </th>
                          </tr>
                          <tr className="border">
                            <th
                              className="border"
                              style={{ textAlign: "center", fontWeight: "500" }}
                            >
                              ACTION
                            </th>
                            <th
                              className="border"
                              style={{ textAlign: "center", fontWeight: "500" }}
                            >
                              Date
                            </th>
                            <th
                              className="border"
                              style={{ textAlign: "center", fontWeight: "500" }}
                            >
                              Invoice Number
                            </th>
                            <th
                              className="border"
                              style={{ textAlign: "center", fontWeight: "500" }}
                            >
                              Invoice Amount
                            </th>
                            <th
                              className="border"
                              style={{ textAlign: "center", fontWeight: "500" }}
                            >
                              Amount Due
                            </th>
                            <th
                              className="border"
                              style={{ textAlign: "center", fontWeight: "500" }}
                            >
                              Payment Received On
                            </th>
                            <th
                              className="border"
                              style={{ textAlign: "center", fontWeight: "500" }}
                            >
                              Payment
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {itemRows.map((itemRow, index) => (
                            <tr key={index}>
                              <td className="border text-center table-class">
                                <button
                                  type="button"
                                  className="delete-button"
                                  onClick={() => handleDeleteRow(index)}
                                >
                                  <Trash2 size={16} color="#dd0b58" />
                                </button>
                              </td>

                              <td className="border table-class">
                                <input
                                  type="date"
                                  name="date"
                                  style={{ outline: "none" }}
                                  value={itemRow.date}
                                  onChange={(e) =>
                                    handleRowChange(
                                      index,
                                      "date",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>


                              <td className="border table-class">
                                <Select
                                  name="invoiceNumber"
                                  options={[]}

                                  onChange={(selectedOption) =>
                                    handleRowChange(index, 'invoiceNumber', selectedOption?.value || '')
                                  }
                                  isClearable
                                  placeholder="Select Invoice"
                                  styles={{ control: (base) => ({ ...base, border: 'none', boxShadow: 'none' }) }}
                                />
                              </td>

                              <td className="border table-class">
                                <input
                                  type="number"
                                  name="invoiceAmount"
                                  style={{ outline: "none" }}
                                  value={itemRow.invoiceAmount}
                                  onChange={(e) =>
                                    handleRowChange(
                                      index,
                                      "invoiceAmount",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>

                              <td className="border table-class">
                                <input
                                  type="number"
                                  name="amountDue"
                                  style={{ outline: "none" }}
                                  value={itemRow.amountDue}
                                  onChange={(e) =>
                                    handleRowChange(
                                      index,
                                      "amountDue",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>

                              <td className="border table-class">
                                <input
                                  type="date"
                                  name="paymentReceivedOn"
                                  style={{ outline: "none" }}
                                  value={itemRow.paymentReceivedOn}
                                  onChange={(e) =>
                                    handleRowChange(
                                      index,
                                      "paymentReceivedOn",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>

                              <td className="border table-class">
                                <input
                                  type="number"
                                  name="payment"
                                  style={{ outline: "none" }}
                                  value={itemRow.payment}
                                  onChange={(e) =>
                                    handleRowChange(
                                      index,
                                      "payment",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          ))}

                          <tr>
                            <td colSpan={7}>
                              <div
                                className="ps-4"
                                style={{ textAlign: "left" }}
                              >
                                <button
                                  type="button"
                                  style={{ outline: "none" }}
                                  onClick={handleAddRow}
                                >
                                  + Add row
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Summary Section */}
                    <div className="row">
                      <div className="d-flex justify-content-end align-items-center w-100">
                        <div
                          className="card mt-3"
                          style={{ width: "50%", borderRadius: "6px" }}
                        >
                          <div className="card-body">
                            {/* Sub Total Section */}
                            <div className="row">
                              <div className="col-lg-6">
                                <p>
                                  <b>Amount Received </b>
                                </p>
                              </div>
                              <div className="col-lg-6 text-end">
                                <p>
                                  <b>0.00</b>
                                </p>
                              </div>
                            </div>
                            {/* Tax Section */}
                            <div
                              className="row"
                              style={{ borderTop: "1px solid #e5e5e5" }}
                            >
                              <div className="col">
                                <b>Amount used for Payments</b>
                              </div>
                              <div className="col text-end">
                                {" "}
                                <b> 0.00</b>
                              </div>
                            </div>
                            <div
                              className="row mt-2"
                              style={{ borderTop: "1px solid #e5e5e5" }}
                            >
                              <div className="col-lg-6 mt-2">
                                <p>
                                  <b>Amount Refunded </b>
                                </p>
                              </div>
                              <div className="col-lg-6 text-end mt-2">
                                <p>
                                  <b>0.00</b>
                                </p>
                              </div>
                            </div>

                            <div
                              className="row mt-2"
                              style={{ borderTop: "1px solid #e5e5e5" }}
                            >
                              <div className="col-lg-6 mt-2">
                                <p>
                                  <b>Amount in Excess</b>
                                </p>
                              </div>
                              <div className="col-lg-6 text-end mt-2">
                                <p>
                                  <b>0.00</b>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </DrawerBody>
          <center>
            <DrawerFooter style={{ display: "inline-block" }}>
              <div className="gap-3 d-flex">
                <button variant="outline" mr={3} className="cancel-button">
                  Cancel
                </button>
                <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handelOnUpdate(e) }} >{isUpdateMode ? "Update" : "Submit"}</button>
              </div>
            </DrawerFooter>
          </center>
        </DrawerContent>
      </Drawer>
    </>
  );
}

export default PaymentReceiveForm;
